export interface ICommitteeReport {
  citation: string
  updateDate: string
  url: string
}
